import { render } from "./Unauthorised.vue?vue&type=template&id=7b3e294a&scoped=true"
import script from "./Unauthorised.vue?vue&type=script&lang=js"
export * from "./Unauthorised.vue?vue&type=script&lang=js"

import "./Unauthorised.vue?vue&type=style&index=0&id=7b3e294a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b3e294a"]])

export default __exports__